import type { PropsWithChildren } from "react";

export default function HeadlineSection({ children } : PropsWithChildren<unknown>) {
  return (
    <div className="text-lg text-secondaryText mb-4">
      {children}
    </div>
  );
}